/*** IMPORTS FROM imports-loader ***/
var define = false;

if (module.hot) {
  const styleInjectionPoint = document.getElementById('style-injection-hook');
  const hotEmitter = require('webpack/hot/emitter');
  const DEAD_CSS_TIMEOUT = 2000;

  hotEmitter.on('webpackHotUpdate', () => {
    document.querySelectorAll('link[href][rel=stylesheet]').forEach((link) => {
      const nextStyleHref = link.href.replace(/(\?\d+)?$/, `?${Date.now()}`);
      const newLink = link.cloneNode(false);
      newLink.href = nextStyleHref;

      link.insertAdjacentElement('afterend', newLink);
      setTimeout(() => {
        link.parentNode.removeChild(link);
      }, DEAD_CSS_TIMEOUT);
    });
  });
}

